// extracted by mini-css-extract-plugin
export default {"addressSection":"xT-z","disabled":"yT-z","sectionButtons":"zT-z","logo":"AT-z"};